import Blogs from "./components/Blogs";
import GetInTouch from "../home/components/GetInTouch";

const index = () => {
  return (
    <>
      <Blogs />
      <GetInTouch />
    </>
  );
};

export default index;
